
import TableList from '@/components/TableList/index.vue';
import { interactiveChannelList } from '@com/utils/channel';
import { exchange } from '@/views/demand/utils';
import { downloadWithIframe } from '@/common/download';
import qs from 'qs';
import { v2Host } from '@/config/host';
import { allNonInteractiveChannelList } from '@/views/demand/utils/creation';

export default {
  components: {
    TableList: TableList
  },

  props: {
    demand: {
      type: Object,
      required: true
    },

    deliverList: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      formConfig: {
        labelWidth: '110px',
        labelPosition: 'right'
      },
      packageDownload: []
    };
  },


  computed: {
    isInteractiveMaterial: function isInteractiveMaterial() {
      return Number(this.demand.type) === 1;
    },
    formItemList: function formItemList() {
      return {
        worktime: {
          label: '工时消耗：',
          prop: 'worktime',
          type: 'plain-text'
        },
        estimated_time: {
          label: '预计完成日期：',
          prop: 'estimated_time',
          type: 'plain-text'
        },
        deliver_time: {
          label: '实际完成日期：',
          prop: 'deliver_time',
          type: 'plain-text'
        }
      };
    },
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '选择',
        prop: 'selection',
        type: 'selection'
      }, {
        visible: !this.isInteractiveMaterial,
        label: '投放渠道',
        prop: 'channel'
      }, {
        label: '创意名称',
        prop: 'name',
        type: 'link',
        params: {
          link: function link(_ref) {
            var row = _ref.row;

            return row.attachment_url;
          }
        }
      }, {
        label: '特征标签',
        prop: 'material_tag_names',
        slot: 'material-tag-cell'
      }, {
        visible: this.isInteractiveMaterial,
        label: '创意地址',
        prop: 'attachment_url'
      }, {
        visible: !this.isInteractiveMaterial,
        slot: 'action-cell'
      }];
    },
    innerDeliverList: function innerDeliverList() {
      var map = {
        channel: this.isInteractiveMaterial ? interactiveChannelList : allNonInteractiveChannelList()
      };
      return this.deliverList.map(function (creation) {
        return exchange(creation, map);
      });
    }
  },

  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.packageDownload = val.map(function (item) {
        return item.id;
      });
    },
    parseTag: function parseTag(row) {
      if (row && row.material_tag_names) {
        return JSON.parse(row.material_tag_names);
      }
      return {};
    },
    handlePackageDownload: function handlePackageDownload() {
      var downloadUrl = v2Host + '/demand/creation/download?' + qs.stringify({
        ids: this.packageDownload.join(),
        demand_id: this.demand.id
      });
      window.location.href = downloadUrl;
    },
    download: function download(url, name) {
      downloadWithIframe(url, name);
    }
  }
};